function showTidio() {
	window.tidioChatApi.show(); 
	window.tidioChatApi.open();
}

export { showTidio }